import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { VersionService } from '@pxl/shared/generated';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { registerLicense } from '@syncfusion/ej2-base';
import { SplashScreenService } from '@pxl/models/contracts';

@Injectable({ providedIn: 'root' })
export class StartupService {
    private readonly isInitialized$ = new BehaviorSubject<boolean>(false);

    private readonly versionService = inject(VersionService);
    private readonly splashScreenService = inject(SplashScreenService);
    private readonly CONFIG = inject(CONFIG_TOKEN);

    public markAsInitialized(): void {
        this.isInitialized$.next(true);
        this.hideSplashScreen();
    }

    public getStatus(): boolean {
        return this.isInitialized$.value;
    }

    public hideSplashScreen(): void {
        this.splashScreenService.hide();
    }

    public loadConfiguration(): Observable<any> {
        registerLicense(this.CONFIG.SYNCFUSION_LICENSE_KEY);
        return of(true);
    }

    public checkApiAvailability(): Observable<any> {
        return this.versionService.availabilityCheck(this.CONFIG.API_VERSION);
    }
}
